import config from '@/data/config';
import { encryptedValue, decryptedValue } from '@/utils/crypto';

const STORAGE_KEY = config.TOKEN_STORAGE_KEY;

export function encryptToken(token) {
  if (typeof token !== 'string' || !token) return token;
  return encryptedValue(token, STORAGE_KEY) || token;
}

// decryptedValue() returns undefined on malformed input, so a legacy plaintext
// token (persisted before this change shipped) transparently passes through unchanged
export function decryptToken(stored) {
  if (typeof stored !== 'string' || !stored) return stored;
  return decryptedValue(stored, STORAGE_KEY) || stored;
}

export function extractTokenFromPersistedBlob(rawJson) {
  if (typeof rawJson !== 'string' || !rawJson) return null;

  try {
    const parsed = JSON.parse(rawJson);
    const token = parsed?.app?.token;

    return typeof token === 'string' && token ? decryptToken(token) : null;
  } catch {
    return null;
  }
}
